import { call, put, takeLatest } from "redux-saga/effects";
import {
  getAllRegionsFetchAction,
  placesAutoCompleteFetchAction,
  searchPlacesByNameAction,
  totalNumberOfRegions,
} from "../api/map-action";
import {
  geTotalRegions,
  getPlacesFromGoogle,
  getPlacesFromGoogleForDestination,
  getRegions,
  setIsLoadingMap,
  setIsTripDestPackageSearchLoading,
  setIsTripPackageSearchLoading,
} from "../redux/app/map/map-slice";
import { toast } from "react-toastify";

// ----------------- TRIP PACKAGE -----------------
export function* placesAutoCompleteTripPackage(actions) {
  try {
    yield put(
      setIsTripPackageSearchLoading({
        isTripPackageSearchLoading: true,
      })
    );
    const response = yield call(placesAutoCompleteFetchAction, actions.payload);

    yield put(
      getPlacesFromGoogle({
        placesbygoogle: response.data,
      })
    );
    yield put(
      setIsTripPackageSearchLoading({
        isTripPackageSearchLoading: false,
      })
    );
  } catch (error) {
    toast.warn(error?.response?.data);
  }
}

export function* placesAutoCompleteDestinationTripPackage(actions) {
  try {
    yield put(
      setIsTripDestPackageSearchLoading({
        isTripDestPackageSearchLoading: true,
      })
    );

    const response = yield call(placesAutoCompleteFetchAction, actions.payload);

    yield put(
      getPlacesFromGoogleForDestination({
        placesbygoogleForDestination: response.data,
      })
    );

    yield put(
      setIsTripDestPackageSearchLoading({
        isTripDestPackageSearchLoading: false,
      })
    );
  } catch (error) {}
}

// ------------------------------ TRIP PACKAGE ------------------------------

export function* placesAutoComplete(actions) {
  try {
    const response = yield call(placesAutoCompleteFetchAction, actions.payload);

    yield put(
      getPlacesFromGoogle({
        placesbygoogle: response.data,
      })
    );
  } catch (error) {
    toast.warn(error?.response?.data);
  }
}

export function* placesAutoCompleteDestination(actions) {
  try {
    const response = yield call(placesAutoCompleteFetchAction, actions.payload);

    yield put(
      getPlacesFromGoogleForDestination({
        placesbygoogleForDestination: response.data,
      })
    );
  } catch (error) {}
}

export function* getRegionsFetchSaga(action) {
  try {
    yield put(
      setIsLoadingMap({
        isLoading: true,
      })
    );
    const response = yield call(getAllRegionsFetchAction, action.payload);

    if (response?.data) {
      yield put(
        setIsLoadingMap({
          isLoading: false,
        })
      );
      yield put(
        getRegions({
          regions: response?.data,
        })
      );
    }
  } catch (error) {}
}

export function* getTotalNumberOfRegionsSaga() {
  try {
    const response = yield call(totalNumberOfRegions);

    yield put(
      geTotalRegions({
        totalRegions: response.data,
      })
    );
  } catch (error) {}
}

export function* searchPlacesByNameSagaSource(actions) {
  try {
    const response = yield call(searchPlacesByNameAction, actions.payload);

    yield put(
      getPlacesFromGoogle({
        placesbygoogle: response.data.data,
      })
    );
  } catch (error) {
    toast.warn(error?.response?.data);
  }
}

export function* searchPlacesByNameSagaDestination(actions) {
  try {
    const response = yield call(searchPlacesByNameAction, actions.payload);

    yield put(
      getPlacesFromGoogleForDestination({
        placesbygoogleForDestination: response?.data?.data,
      })
    );
  } catch (error) {
    toast.warn(error?.response?.data);
  }
}

export function* watchMapAsync() {
  yield takeLatest(
    "GET_PLACES_FROM_GOOGLE_TRIP_PACKAGE",
    placesAutoCompleteTripPackage
  );
  yield takeLatest(
    "GET_PLACES_FROM_GOOGLE_FOR_DEST_TRIP_PACKAGE",
    placesAutoCompleteDestinationTripPackage
  );
  yield takeLatest("GET_PLACES_FROM_GOOGLE", placesAutoComplete);
  yield takeLatest(
    "GET_PLACES_FROM_GOOGLE_FOR_DEST",
    placesAutoCompleteDestination
  );
  yield takeLatest("GET_REGIONS", getRegionsFetchSaga);
  yield takeLatest("GET_TOTAL_REGIONS", getTotalNumberOfRegionsSaga);
  yield takeLatest(
    "SEARCH_PLACES_BY_NAME_SOURCE",
    searchPlacesByNameSagaSource
  );
  yield takeLatest(
    "SEARCH_PLACES_BY_NAME_DEST",
    searchPlacesByNameSagaDestination
  );
}
